// Each step has id, label (for sidebar), path, and element (page component)
import ProjectInfoStepPage from "../pages/ProjectSteps/ProjectInfoStepPage";
import TrainingDataStepPage from "../pages/ProjectSteps/TrainingDataStepPage";
import TrainingsStepPage from "../pages/ProjectSteps/TrainingsStepPage";
import TestingStepPage from "../pages/ProjectSteps/TestingStepPage";
import BenchmarkingStepPage from "../pages/ProjectSteps/BenchmarkingStepPage";

export const createProjectSteps = [
  { id: 'project_info', label: 'Project Info', path: 'info', element: <ProjectInfoStepPage /> },
  { id: 'training_data', label: 'Training Data', path: 'training_data', element: <TrainingDataStepPage /> },
  { id: 'trainings', label: 'Trainings', path: 'trainings', element: <TrainingsStepPage /> },
  { id: 'testing', label: 'Testing', path: 'testing', element: <TestingStepPage /> },
  // { id: 'benchmarking', label: 'Benchmarking', path: 'benchmarking', element: <BenchmarkingStepPage /> },
];
